import _ from 'underscore';

const allCurrencies = [
  { key: 'ALL', title: 'ALL', tl: _TL_('Albanian Lek (ALL)') },
  { key: 'AED', title: 'AED', tl: _TL_('United Arab Emirates Dirham (AED)') },
  { key: 'ARS', title: 'ARS', tl: _TL_('Argentine Peso (ARS)') },
  { key: 'AMD', title: 'AMD', tl: _TL_('Armenian Dram (AMD)') },
  { key: 'AUD', title: 'AUD', tl: _TL_('Australian Dollar (AUD)') },
  { key: 'AZN', title: 'AZN', tl: _TL_('Azerbaijani Manat (AZN)') },
  { key: 'BHD', title: 'BHD', tl: _TL_('Bahraini Dinar (BHD)') },
  { key: 'BDT', title: 'BDT', tl: _TL_('Bangladeshi Taka (BDT)') },
  { key: 'BZD', title: 'BZD', tl: _TL_('Belize Dollar (BZD)') },
  { key: 'BOB', title: 'BOB', tl: _TL_('Bolivian Boliviano (BOB)') },
  { key: 'BWP', title: 'BWP', tl: _TL_('Botswanan Pula (BWP)') },
  { key: 'BRL', title: 'BRL', tl: _TL_('Brazilian Real (BRL)') },
  { key: 'GBP', title: 'GBP', tl: _TL_('British Pound (GBP)') },
  { key: 'BND', title: 'BND', tl: _TL_('Brunei Dollar (BND)') },
  { key: 'BGN', title: 'BGN', tl: _TL_('Bulgarian Lev (BGN)') },
  { key: 'CAD', title: 'CAD', tl: _TL_('Canadian Dollar (CAD)') },
  { key: 'CHF', title: 'CHF', tl: _TL_('Swiss Franc (CHF)') },
  { key: 'CLP', title: 'CLP', tl: _TL_('Chilean Peso (CLP)') },
  { key: 'CNY', title: 'CNY', tl: _TL_('Chinese Yuan (CNY)') },
  { key: 'COP', title: 'COP', tl: _TL_('Colombian Peso (COP)') },
  { key: 'CRC', title: 'CRC', tl: _TL_('Costa Rican Colón (CRC)') },
  { key: 'CZK', title: 'CZK', tl: _TL_('Czech Republic Koruna (CZK)') },
  { key: 'DKK', title: 'DKK', tl: _TL_('Danish Krone (DKK)') },
  { key: 'DOP', title: 'DOP', tl: _TL_('Dominican Peso (DOP)') },
  { key: 'DZD', title: 'DZD', tl: _TL_('Algerian Dinar (DZD)') },
  { key: 'XCD', title: 'XCD', tl: _TL_('East Caribbean Dollar (XCD)') },
  { key: 'EGP', title: 'EGP', tl: _TL_('Egyptian Pound (EGP)') },
  { key: 'ETB', title: 'ETB', tl: _TL_('Ethiopian Birr (ETB)') },
  { key: 'EUR', title: 'EUR', tl: _TL_('Euro (EUR)') },
  { key: 'FJD', title: 'FJD', tl: _TL_('Fijian Dollar (FJD)') },
  { key: 'GEL', title: 'GEL', tl: _TL_('Georgian Lari (GEL)') },
  { key: 'GHS', title: 'GHS', tl: _TL_('Ghanian Cedi (GHS)') },
  { key: 'GTQ', title: 'GTQ', tl: _TL_('Guatemalan Quetzal (GTQ)') },
  { key: 'HNL', title: 'HNL', tl: _TL_('Honduran Lempira (HNL)') },
  { key: 'HKD', title: 'HKD', tl: _TL_('Hong Kong Dollar (HKD)') },
  { key: 'HRK', title: 'HRK', tl: _TL_('Croatian Kuna (HRK)') },
  { key: 'HUF', title: 'HUF', tl: _TL_('Hungarian Forint (HUF)') },
  { key: 'ISK', title: 'ISK', tl: _TL_('Icelandic Króna (ISK)') },
  { key: 'INR', title: 'INR', tl: _TL_('Indian Rupee (INR)') },
  { key: 'IDR', title: 'IDR', tl: _TL_('Indonesian Rupiah (IDR)') },
  { key: 'IQD', title: 'IQD', tl: _TL_('Iraqi Dinar (IQD)') },
  { key: 'ILS', title: 'ILS', tl: _TL_('Israeli New Shekel (ILS)') },
  { key: 'JMD', title: 'JMD', tl: _TL_('Jamaican Dollar (JMD)') },
  { key: 'JPY', title: 'JPY', tl: _TL_('Japanese Yen (JPY)') },
  { key: 'JOD', title: 'JOD', tl: _TL_('Jordanian Dinar (JOD)') },
  { key: 'KZT', title: 'KZT', tl: _TL_('Kazakhstani Tenge (KZT)') },
  { key: 'KES', title: 'KES', tl: _TL_('Kenyan Shilling (KES)') },
  { key: 'KWD', title: 'KWD', tl: _TL_('Kuwaiti Dinar (KWD)') },
  { key: 'KGS', title: 'KGS', tl: _TL_('Kyrgyzstani Som (KGS)') },
  { key: 'KRW', title: 'KRW', tl: _TL_('South Korea Won (KRW)') },
  { key: 'LBP', title: 'LBP', tl: _TL_('Lebanese Pound (LBP)') },
  { key: 'LKR', title: 'LKR', tl: _TL_('Sri Lankan Rupee (LKR)') },
  { key: 'LYD', title: 'LYD', tl: _TL_('Libyan Dinar (LYD)') },
  { key: 'MOP', title: 'MOP', tl: _TL_('Macanese Pataca (MOP)') },
  { key: 'MKD', title: 'MKD', tl: _TL_('Macedonian Denar (MKD)') },
  { key: 'MWK', title: 'MWK', tl: _TL_('Malawi Kwacha (MWK)') },
  { key: 'MYR', title: 'MYR', tl: _TL_('Malaysian Ringgit (MYR)') },
  { key: 'MVR', title: 'MVR', tl: _TL_('Maldivian Rufiyaa (MVR)') },
  { key: 'MUR', title: 'MUR', tl: _TL_('Mauritian Rupee (MUR)') },
  { key: 'MXN', title: 'MXN', tl: _TL_('Mexican Peso (MXN)') },
  { key: 'MNT', title: 'MNT', tl: _TL_('Mongolian Tugrik (MNT)') },
  { key: 'MAD', title: 'MAD', tl: _TL_('Moroccan Dirham (MAD)') },
  { key: 'NZD', title: 'NZD', tl: _TL_('New Zealand Dollar (NZD)') },
  { key: 'NIO', title: 'NIO', tl: _TL_('Nicaraguan Córdoba (NIO)') },
  { key: 'NGN', title: 'NGN', tl: _TL_('Nigerian Naira (NGN)') },
  { key: 'NOK', title: 'NOK', tl: _TL_('Norwegian Krone (NOK)') },
  { key: 'OMR', title: 'OMR', tl: _TL_('Omani Rial (OMR)') },
  { key: 'PKR', title: 'PKR', tl: _TL_('Pakistani Rupee (PKR)') },
  { key: 'PAB', title: 'PAB', tl: _TL_('Panamian Balboa (PAB)') },
  { key: 'PYG', title: 'PYG', tl: _TL_('Paraguayan Guarani (PYG)') },
  { key: 'PEN', title: 'PEN', tl: _TL_('Peruvian Nuevo Sol (PEN)') },
  { key: 'PHP', title: 'PHP', tl: _TL_('Philippine Peso (PHP)') },
  { key: 'PLN', title: 'PLN', tl: _TL_('Polish Zloty (PLN)') },
  { key: 'QAR', title: 'QAR', tl: _TL_('Qatari Riyal (QAR)') },
  { key: 'RON', title: 'RON', tl: _TL_('Romanian Leu (RON)') },
  { key: 'RSD', title: 'RSD', tl: _TL_('Serbian Dinar (RSD)') },
  { key: 'RUB', title: 'RUB', tl: _TL_('Russian Ruble (RUB)') },
  { key: 'RWF', title: 'RWF', tl: _TL_('Rwandan Franc (RWF)') },
  { key: 'SAR', title: 'SAR', tl: _TL_('Saudi Riyal (SAR)') },
  { key: 'SEK', title: 'SEK', tl: _TL_('Swedish Krona (SEK)') },
  { key: 'SGD', title: 'SGD', tl: _TL_('Singapore Dollar (SGD)') },
  { key: 'TZS', title: 'TZS', tl: _TL_('Tanzanian Shilling (TZS)') },
  { key: 'THB', title: 'THB', tl: _TL_('Thai Baht (THB)') },
  { key: 'TOP', title: 'TOP', tl: _TL_('Tongan Pa\'anga (TOP)') },
  { key: 'TTD', title: 'TTD', tl: _TL_('Trinidad and Tobago Dollar (TTD)') },
  { key: 'TND', title: 'TND', tl: _TL_('Tunisian Dinar (TND)') },
  { key: 'TRY', title: 'TRY', tl: _TL_('Turkish Lira (TRY)') },
  { key: 'TWD', title: 'TWD', tl: _TL_('New Taiwan Dollar (TWD)') },
  { key: 'UGX', title: 'UGX', tl: _TL_('Ugandan Shilling (UGX)') },
  { key: 'UAH', title: 'UAH', tl: _TL_('Ukrainian Hryvnia (UAH)') },
  { key: 'UYU', title: 'UYU', tl: _TL_('Uruguayan Peso (UYU)') },
  { key: 'USD', title: 'USD', tl: _TL_('US Dollar (USD)') },
  { key: 'UZS', title: 'UZS', tl: _TL_('Uzbekistani Som (UZS)') },
  { key: 'VEF', title: 'VEF', tl: _TL_('Venezuelan Bolivar (VEF)') },
  { key: 'VND', title: 'VND', tl: _TL_('Vietnamese Dong (VND)') },
  { key: 'XAF', title: 'XAF', tl: _TL_('Central African CFA Franc (XAF)') },
  { key: 'XOF', title: 'XOF', tl: _TL_('West African CFA Franc (XOF)') },
  { key: 'YER', title: 'YER', tl: _TL_('Yemeni Rial (YER)') },
  { key: 'ZAR', title: 'ZAR', tl: _TL_('South African Rand (ZAR)') },
  { key: 'ZMW', title: 'ZMW', tl: _TL_('Zambian Kwacha (ZMW)') },
];

const escSupportedCurrenciesSorted = [
  'AED',
  'ARS',
  'AUD',
  'BDT',
  'BOB',
  'BRL',
  'CAD',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CZK',
  'DKK',
  'DZD',
  'EGP',
  'EUR',
  'GBP',
  'HKD',
  'HUF',
  'IDR',
  'ILS',
  'INR',
  'JPY',
  'KES',
  'KRW',
  'MOP',
  'MXN',
  'MYR',
  'NIO',
  'NOK',
  'NZD',
  'PEN',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RUB',
  'SAR',
  'SEK',
  'SGD',
  'THB',
  'TRY',
  'TWD',
  'USD',
  'UYU',
  'VEF',
  'VND',
];

const escCurrencies = _.filter(allCurrencies, c => _.indexOf(escSupportedCurrenciesSorted, c.key, true) >= 0);

/**
 * Gets the list of currencies supported for conversion tracking revenue.
 * @param {*} i18n - Used to localize the names of the currencies.
 * @param {Boolean} isESCMigrationFeaturesEnabled - True if migration features are enabled.
 * @returns {Object[]} - List of all the supported currencies for conversion tracking revenue.
 */
export const getCurrencyOptions = (i18n, isESCMigrationFeaturesEnabled = false) => {
  // Customers migrated from Smart Campaigns will see more currency options
  const currenciesBeforeLocalization = isESCMigrationFeaturesEnabled ? allCurrencies : escCurrencies;

  const currencyOptions = _.map(
    currenciesBeforeLocalization,
    ({ key, title, tl }) => ({ key, title, text: i18n.getString(tl) })
  );
  currencyOptions.sort((a, b) => a.text.localeCompare(b.text));
  return currencyOptions;
};
